<template>
    <b-notification has-icon :closable="false" type="is-danger is-light" icon="info-circle"
        aria-close-label="Close notification" role="alert">
        <span v-if="type === 'HEADERS'">
            <p>
                No se pudo validar tu archivo, parece que modificaste los
                <strong>títulos de las columnas.</strong>
            </p> <br />
            <p>
                Descarga nuevamente la plantilla base en el botón que está justo arriba y
                vuelve a intentarlo.
            </p>
        </span>
        <span v-if="type === 'FILES'">
            <p>
                No se pudo subir tu archivo, ocurrio un error en
                <strong>la subida</strong>, intente nuevamente, gracias.
            </p> <br />
        </span>
        <span v-else>
            <p>
                No se pudo validar tu archivo, por favor revisa las
                siguientes columnas e inténtalo nuevamente: <br /><br />
            </p>
            <li v-for="(value, key) in msg" :key="key">
                <strong>{{ key }}</strong> : {{ value }}
            </li>
        </span>
    </b-notification>
</template>

<script>
export default {
    name: "ErrorNotification",
    props: ["msg", "type"],
};
</script>
